import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductPricingPlanClass.Save.IRequest;
type Response = Api.Core.ProductPricingPlanClass.Save.IResponse;
type Headers = Api.Core.ProductPricingPlanClass.Save.IHeaders;
const url = '/api/ProductManagement/ProductPricingPlanClass';
export default async function productPricingPlanClassSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
